// Angular
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
// Service
import { ConfigService } from '@cv-invision/core';
import { ViewsService } from '../../../../../services/views.service';
import { LocationPhotoUtilsService } from '../../../../services/location-photo-utils.service';
import { LayoutRenderService } from '../../../services/layout-render.service';
// Model
import { MapViewConfigModel } from '@cv-invision/cv.component-library.ux'
import { MapLocationConfigModel } from './model/map-location.config.model';
import { MapLocationDesign, MapLocationOptions } from '../../models/components.options';
import { LayoutComponentBroadcast, LayoutRenderLayoutItem } from '../../../models/cv-layout-render.model';
import { GeneralEventType } from '../../models/component.events';
import { PROPERTY_TYPE } from '../../../../models/property-const.model';
import { SCHEMA_TYPE } from '../../../../../models/enums.model';
// Other
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'cv-schema-render-map-location',
	templateUrl: './map-location.component.html'
})
export class MapLocationComponent implements OnInit, OnDestroy {
	@Input() data: any;
	@Input() layoutNode = new LayoutRenderLayoutItem();
	public layoutDesign = MapLocationDesign;
	public options = new MapLocationOptions();
	public mapConfiguration = new MapViewConfigModel();
	public mapLocationConfiguration = new MapLocationConfigModel();
	public isPinSelectorMode = false;
	public isMapDisabled = false;
	public enabledMapControls = false;

	private atComponentDestroy = new Subject();
	public newMarker: { lat: any, lng: any } = null;

	constructor(
		private configService: ConfigService,
		private viewService: ViewsService,
		private layoutRenderService: LayoutRenderService,
		private locationPhotoUtilsService: LocationPhotoUtilsService
	) {
	}

	ngOnInit(): void {
		this.options = { ...this.options, ...this.layoutNode.options };
		// Set Map Center
		this.mapConfiguration.setMapKey(this.configService.publicKey.googleMaps);
		this.mapConfiguration.setMainLocation(this.viewService.document.InspectionReport.property.identification.gpsCoordinates, 'assets/img/marker/marker-user-location-l.png');

		const schemasShouldExcludeExteriorRooms = [
			SCHEMA_TYPE.CVDS_40.toString(),
			SCHEMA_TYPE.INSPECTIONLESS_1.toString(),
		];

		const includeExteriorRooms = schemasShouldExcludeExteriorRooms.indexOf(this.viewService.order.schema) === -1;

		// Set Room and Smart Tag Photo Positions
		const optionsFilter = this.options.filterSmartTagOptions;
		this.mapConfiguration.setLocations(
			this.mapLocationConfiguration.getLocations(
				this.data, this.viewService.photos,
				this.locationPhotoUtilsService,
				includeExteriorRooms,
				optionsFilter
				)
			);

		// Listen to change on Map to reload only what is needed, executed after DATA_UPDATED
		this.layoutRenderService.componentBroadcast
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((broadcastData: LayoutComponentBroadcast) => {
				if (broadcastData.eventType === GeneralEventType.DATA_UPDATED && broadcastData.jsonPath === this.data._Path) {
					if (broadcastData.metaData.isCreate) {
						this.mapConfiguration.locationModels = this.mapLocationConfiguration.addLocation(broadcastData.metaData.data, PROPERTY_TYPE.LOCATION, this.locationPhotoUtilsService);
					} else if (broadcastData.metaData.isReplace) {
						this.mapConfiguration.locationModels =  this.mapLocationConfiguration.updateLocations(this.data.smartTags, PROPERTY_TYPE.LOCATION, this.locationPhotoUtilsService);
					}
				}
			});
	}

	/**
	 * Enable Clickable Pin Mode to set a Pin in the Map
	 */
	public changePinSelectorMode(enabled: boolean): void {
		// Enable Pin Mode
		this.isPinSelectorMode = enabled;
		if (!enabled) {
			this.newMarker = null
		}
		this.changeMapControls(!enabled);
	}

	private changeMapControls(enabled: boolean): void {
		this.mapConfiguration.options.fullscreenControl = enabled;
		this.mapConfiguration.options.streetViewControl = enabled;
	}

	/**
	 * Enable or Disable the map
	 * @param mapDisabled
	 */
	public disableMap(mapDisabled: boolean): void {
		this.isMapDisabled = mapDisabled;
	}

	onNewMarker(newMarker) {
		this.newMarker = newMarker;
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
